import { useState } from 'react';
import { toast } from 'react-toastify';
import authService from 'services/auth';
import styles from './login.module.scss';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import LogoAsia from 'assets/images/Logo.svg';
import { useNavigate } from 'react-router-dom';
import { setLoginData, setUserData } from 'redux/slices/auth';
import { useMutation } from '@tanstack/react-query';
import { LoginResponse } from 'interfaces/user.types';
import ImageLogin from 'assets/images/login-right-img.png';
import { CustomInput, CustomButton, CustomInputPassword } from 'components';
import { ReactComponent as IconPerson } from 'assets/icons/icon_person-input.svg';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [check, setCheck] = useState(false);
  const { loginData } = useSelector((state: any) => state.auth, shallowEqual);
  const togglePwd = () => setShowPassword(!showPassword);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginResponse>({
    defaultValues: {
      email: loginData?.email || 'user@example.com',
      password: loginData?.password || 'string',
    },
  });

  const { mutate } = useMutation({
    mutationFn: (data: any) => authService.login(data),
    onSuccess: (res: any) => {
      dispatch(
        setUserData({
          user_id: res.user_id,
          role: res.user_type,
          username: res.username,
          email: res.email,
        })
      );

      localStorage.setItem('token', res?.access);
      navigate('/');
    },
    onError: (error: any) => {
      toast.error(error?.data?.detail);
    },
  });

  const formSubmit = (data: LoginResponse) => {
    const params = {
      email: data.email,
      password: data.password,
    };

    mutate(params);
    if (check) {
      dispatch(
        setLoginData({
          email: data.email,
          password: data.password,
        })
      );
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.wrapper}>
        <div className={styles.leftSide}>
          <img className={styles.leftSideLogo} src={LogoAsia} alt='logoAsiaLine' />
          <h2 className={styles.title}>Авторизация</h2>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div className={styles.inputsContainer}>
              <CustomInput
                name='email'
                type='email'
                label='Email:'
                error={errors}
                control={control}
                icon={<IconPerson />}
              />
              <CustomInputPassword
                error={errors}
                name='password'
                label='Пароль:'
                control={control}
                showPassword={showPassword}
                togglePwd={togglePwd}
              />
              <div className={styles.checkbox}>
                <Checkbox
                  {...label}
                  checked={check}
                  onChange={(e) => setCheck(e.target.checked)}
                  value={check}
                  sx={{
                    color: '#005AA9 !important',
                    '&.Mui-checked': {
                      color: '#005AA9 !important',
                    },
                  }}
                />
                <span>Запомнить меня</span>
              </div>
            </div>
            <CustomButton text='Войти' type='submit' style={{ width: '100%' }} />
          </form>
        </div>
        <div className={styles.rightSide}>
          <img src={ImageLogin} alt='imageLoginPage' />
        </div>
      </div>
    </div>
  );
};

export default Login;
